import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationService } from '../../../../services/navigation.service';
import { HtmlDescriptionFieldComponent } from '../../../fields/standard/html-description-field/html-description-field.component';
import { NameFieldComponent } from '../../../fields/standard/name-field/name-field.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { TextUtils, Unit, UnitText, _ } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { PreviousImageSelectorComponent } from '../../../ui/admin/previous-image-selector/previous-image-selector.component';

@Component({
	selector: 'app-unit-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		NameFieldComponent,
		HtmlDescriptionFieldComponent,
		TextFieldComponent,
		FormTitleComponent,
		PreviousImageSelectorComponent,
	],
	templateUrl: './unit-form.component.html',
	styleUrl: './unit-form.component.scss',
})
export class UnitFormComponent implements OnInit {
	@Input('unit') public unit: Unit | undefined;
	@Input('editLanguage') public editLanguage: string | undefined;
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public showPreviousImageSelector: boolean = false;

	public form: FormGroup = this.fb.group({
		name: ['', NameFieldComponent.validators],
		descriptionHtml: ['', TextFieldComponent.validators],
		descriptionShort: ['', HtmlDescriptionFieldComponent.validators],
		imageUri: ['', []],
		//dataJson: ['', []],
	});

	constructor(
		private fb: FormBuilder,
		public nav: NavigationService
	) {}

	public onSubmit() {
		const value = this.form.getRawValue();

		this.onSubmitEmitter.emit({
			...value,
			descriptionShort: TextUtils.toOptionalText(value.descriptionShort),
			descriptionHtml: TextUtils.toOptionalText(value.descriptionHtml),
		});
	}

	public clear(): void {
		this.form.reset();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (_.get(changes, 'editLanguage', undefined) || _.get(changes, 'unit', undefined)) {
			if (changes['unit']) {
				const newUnit: Unit | undefined = _.get(changes, 'unit.currentValue', this.unit) as Unit | undefined;

				this.unit = newUnit;
			}

			const newUnitText: UnitText | undefined = this.unit
				? this.unit.unit_text.find((text: UnitText) => text.default_lang_id === this.editLanguage)
				: undefined;

			this.form.patchValue({
				name: newUnitText?.name || '',
				descriptionHtml: newUnitText?.description_html ?? null,
				descriptionShort: newUnitText?.description_short ?? null,
				imageUri: newUnitText?.image_uri || '',
				//dataJson: this.unit?.data_json ? JSON.stringify(this.unit?.data_json) : '',
			});
		}
	}

	public selectImageUri(imageUri: string): void {
		this.form.patchValue({ imageUri });
		this.showPreviousImageSelector = false;
	}

	ngOnInit() {}
}
